import React, { FC } from 'react';
import { ImageSection } from 'components/energy5/structures';
import { selectionImage } from 'assets/images/led-landing';
import useI18n from "evcharging/hooks/useI18n";

const ConfirmSelectionSection: FC = () => {
  const { t } = useI18n();

  return (
    <ImageSection
      title={t('landing.confirm.title')}
      text={t('landing.confirm.description')}
      imageSrc={selectionImage}
      width={1200}
      height={676}
      showBlueBgEffect
      imageBigLg
      imageLeft
      setImageBorder
    />
  );
};

export default ConfirmSelectionSection;
